import React from 'react'
import styles
  from './OrderForwardingSummaryPdfChip.module.css'
import { CircularProgress, IconButton, Tooltip } from '@material-ui/core'
import { ReactComponent as DownloadIcon } from 'assets/icons/add.svg'
import { ReactComponent as MailIcon } from 'assets/icons/mail.svg'
import { ReactComponent as CheckIcon } from 'assets/icons/check-copy-10.svg'
import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg'
import { useTranslation } from 'react-i18next'

export const OrderForwardingSummaryPdfChip = ({
  filename,
  onDownloadClick,
  onSendMailClick,
  onDeleteClick,
  isSentMailInProgress,
  isSendMailDone,
}) => {
  const { t } = useTranslation()

  const renderSendComponent = () => {
    if (isSendMailDone) {
      return (
        <Tooltip title={t(
          'order.details.orderForwardingSummaryPdf.sendSuccessTooltip')}>
          <div className={styles.actionContainer}>
            <CheckIcon/>
          </div>
        </Tooltip>
      )
    }
    if (isSentMailInProgress) {
      return (
        <div className={styles.actionContainer}>
          <CircularProgress size={24}/>
        </div>
      )
    }
    return (
      <Tooltip title={t('order.details.orderForwardingSummaryPdf.sendTooltip')}>
        <div className={styles.actionContainer}>
          <IconButton className={styles.button}
                      onClick={() => onSendMailClick()}>
            <MailIcon/>
          </IconButton>
        </div>
      </Tooltip>
    )
  }

  return (
    <div className={styles.container}>
      <span className={styles.filename}>{filename}</span>
      <Tooltip
        title={t('order.details.orderForwardingSummaryPdf.downloadTooltip')}>
        <div className={styles.actionContainer}>
          <IconButton className={styles.button}
                      onClick={() => onDownloadClick()}>
            <DownloadIcon/>
          </IconButton>
        </div>
      </Tooltip>
      {renderSendComponent()}
      <Tooltip
        title={t('order.details.orderForwardingSummaryPdf.deleteTooltip')}>
        <div className={styles.actionContainer}>
          <IconButton className={styles.button}
                      onClick={() => onDeleteClick()}>
            <TrashIcon/>
          </IconButton>
        </div>
      </Tooltip>
    </div>
  )
}